import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { moduleQueryKeys } from "./query-keys";
import { PaginatedModuleClientsResponse } from "./types";

import { instance } from "@/lib/axios/instance";

interface UseModuleClientsParams {
  tenantId: string;
  integrationName: string;
  moduleName: string;
  page?: number;
  pageSize?: number;
  search?: string;
  moduleStatus?: "active" | "inactive" | null;
  orderBy?: string | null;
  descending?: boolean | null;
}

export function useModuleClients({
  tenantId,
  integrationName,
  moduleName,
  page = 1,
  pageSize = 10,
  search,
  moduleStatus,
  orderBy,
  descending,
}: UseModuleClientsParams): UseQueryResult<
  PaginatedModuleClientsResponse,
  AxiosError
> {
  return useQuery({
    queryKey: moduleQueryKeys.clientsList({
      integrationName,
      moduleName,
      tenantId,
      page,
      pageSize,
      search,
      moduleStatus,
      orderBy,
      descending,
    }),
    queryFn: () =>
      instance
        .get<PaginatedModuleClientsResponse>(
          `/api/v2/Integrations/${encodeURIComponent(integrationName)}/${encodeURIComponent(moduleName)}/clients`,
          {
            params: {
              tenantId,
              page,
              pageSize,
              ...(search && { search }),
              ...(moduleStatus && { moduleStatus }),
              ...(orderBy && { orderBy }),
              ...(descending !== null &&
                descending !== undefined && {
                descending: descending.toString(),
              }),
            },
          }
        )
        .then((res) => res.data),
    enabled: !!tenantId && !!integrationName && !!moduleName,
    refetchOnReconnect: false,
    staleTime: 20 * 60 * 1000,
  });
}
